import { Stack } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { selectArguments, selectValues } from "../../../../store/selectors/fieldsStateSelectors.ts";
import ArgumentAxisStyles from "./argumentAxis/ArgumentAxisStyles.tsx";
import ChartStyles from "./chart/ChartStyles.tsx";
import LegendStyles from "./legend/LegendStyles.tsx";
import SeriesStyles from "./serie/SeriesStyles.tsx";
import ValueAxisStyles from "./valueAxis/ValueAxisStyles.tsx";

export default function StyleContainer({ readonlyMode }: { readonlyMode: boolean }) {
  const argumentsAreaValues = useSelector(selectArguments);
  const valuesAreaValues = useSelector(selectValues);

  const configurationValid = React.useMemo(() => {
    return argumentsAreaValues.length > 0 && valuesAreaValues.length > 0;
  }, [argumentsAreaValues, valuesAreaValues]);

  if (!configurationValid) {
    return <></>;
  }

  return (
    <Stack sx={{ mt: -2, flex: 1, position: "relative", width: "100%" }}>
      <Stack sx={{ position: "absolute", height: "100%", width: "100%", overflow: "auto" }}>
        <ChartStyles readonlyMode={readonlyMode} />
        <SeriesStyles readonlyMode={readonlyMode} />
        <ArgumentAxisStyles readonlyMode={readonlyMode} />
        <ValueAxisStyles readonlyMode={readonlyMode} />
        <LegendStyles readonlyMode={readonlyMode} />
      </Stack>
    </Stack>
  );
}
